(function() {
  'use strict';

  function BestSellersTabs(container) {
    this.container = container;
    this.tabs = this.container.querySelectorAll('[data-action="switch-tab"]');
    this.panels = this.container.querySelectorAll('.BestSellers__TabPanel');
    this.scrollContainers = this.container.querySelectorAll('[data-scroll-container]');
    
    this.init();
  }

  BestSellersTabs.prototype.init = function() {
    var self = this;
    
    this.tabs.forEach(function(tab) {
      tab.addEventListener('click', function(e) {
        e.preventDefault();
        var tabIndex = parseInt(this.getAttribute('data-tab-index'));
        self.switchTab(tabIndex);
      });
    });

    this.scrollContainers.forEach(function(scrollContainer, index) {
      var scrollBar = self.panels[index].querySelector('[data-scroll-bar]');
      var productsList = scrollContainer.querySelector('.BestSellers__ProductsList');
      
      if (scrollBar && productsList) {
        self.updateScrollBar(scrollContainer, scrollBar, productsList);
        
        scrollContainer.addEventListener('scroll', function() {
          self.updateScrollBar(scrollContainer, scrollBar, productsList);
        });

        window.addEventListener('resize', function() {
          self.updateScrollBar(scrollContainer, scrollBar, productsList);
        });

        self.initDragScroll(scrollContainer);
        self.initScrollBarDrag(scrollContainer, scrollBar, productsList);
      }
    });
  };

  BestSellersTabs.prototype.initDragScroll = function(scrollContainer) {
    var isDown = false;
    var startX;
    var startY;
    var scrollLeft;
    var hasMoved = false;
    var hasMovedHorizontally = false;
    var dragThreshold = 5;
    var clickedLink = null;
    var clickedElement = null;

    // Mouse events
    scrollContainer.addEventListener('mousedown', function(e) {
      var targetLink = e.target.tagName === 'A' ? e.target : e.target.closest('a');
      var targetButton = e.target.tagName === 'BUTTON' ? e.target : e.target.closest('button');
      
      // Don't interfere with arrow buttons and carousel dots - let them work normally
      if (targetButton && (targetButton.classList.contains('ProductItem__NavArrow') || targetButton.classList.contains('ProductItem__Dot'))) {
        return;
      }
      
      isDown = true;
      hasMoved = false;
      hasMovedHorizontally = false;
      startX = e.pageX;
      startY = e.pageY;
      scrollLeft = scrollContainer.scrollLeft;
      clickedLink = targetLink;
      clickedElement = e.target;
      
      if (clickedLink) {
        e.preventDefault();
      }
    });

    scrollContainer.addEventListener('mouseleave', function() {
      isDown = false;
      hasMoved = false;
      hasMovedHorizontally = false;
      scrollContainer.classList.remove('is-dragging');
      clickedLink = null;
      clickedElement = null;
    });

    scrollContainer.addEventListener('mouseup', function(e) {
      if (isDown && clickedLink && !hasMoved) {
        window.location.href = clickedLink.href;
      }
      
      isDown = false;
      hasMoved = false;
      hasMovedHorizontally = false;
      scrollContainer.classList.remove('is-dragging');
      clickedLink = null;
      clickedElement = null;
    });

    scrollContainer.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      
      var deltaX = Math.abs(e.pageX - startX);
      var deltaY = Math.abs(e.pageY - startY);
      
      if (!hasMoved && (deltaX > dragThreshold || deltaY > dragThreshold)) {
        hasMoved = true;
      }
      
      if (hasMoved && deltaX > deltaY) {
        hasMovedHorizontally = true;
        scrollContainer.classList.add('is-dragging');
        e.preventDefault();
        var x = e.pageX - scrollContainer.offsetLeft;
        var walk = (x - (startX - scrollContainer.offsetLeft)) * 2;
        scrollContainer.scrollLeft = scrollLeft - walk;
      }
    });
    
    scrollContainer.addEventListener('click', function(e) {
      if (hasMoved) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    }, true);

    // Touch events for mobile
    scrollContainer.addEventListener('touchstart', function(e) {
      var targetLink = e.target.tagName === 'A' ? e.target : e.target.closest('a');
      var targetButton = e.target.tagName === 'BUTTON' ? e.target : e.target.closest('button');
      
      // Don't interfere with arrow buttons and carousel dots - let them work normally
      if (targetButton && (targetButton.classList.contains('ProductItem__NavArrow') || targetButton.classList.contains('ProductItem__Dot'))) {
        return;
      }
      
      var touch = e.touches[0];
      isDown = true;
      hasMoved = false;
      hasMovedHorizontally = false;
      startX = touch.pageX;
      startY = touch.pageY;
      scrollLeft = scrollContainer.scrollLeft;
      clickedLink = targetLink;
      clickedElement = e.target;
    }, { passive: true });

    scrollContainer.addEventListener('touchend', function(e) {
      if (isDown && clickedLink && !hasMoved) {
        e.preventDefault();
        window.location.href = clickedLink.href;
      }
      
      // Small delay to prevent click events after drag
      if (hasMoved) {
        setTimeout(function() {
          isDown = false;
          hasMoved = false;
          hasMovedHorizontally = false;
          scrollContainer.classList.remove('is-dragging');
          clickedLink = null;
          clickedElement = null;
        }, 50);
      } else {
        isDown = false;
        hasMoved = false;
        hasMovedHorizontally = false;
        scrollContainer.classList.remove('is-dragging');
        clickedLink = null;
        clickedElement = null;
      }
    });

    scrollContainer.addEventListener('touchmove', function(e) {
      if (!isDown) return;
      
      var touch = e.touches[0];
      var deltaX = Math.abs(touch.pageX - startX);
      var deltaY = Math.abs(touch.pageY - startY);
      
      // Detect any movement beyond threshold
      if (!hasMoved && (deltaX > dragThreshold || deltaY > dragThreshold)) {
        hasMoved = true;
      }
      
      // Only engage horizontal scrolling if the movement is clearly horizontal
      if (hasMoved && deltaX > deltaY && deltaX > dragThreshold) {
        hasMovedHorizontally = true;
        scrollContainer.classList.add('is-dragging');
        e.preventDefault();
        var x = touch.pageX - scrollContainer.offsetLeft;
        var walk = (x - (startX - scrollContainer.offsetLeft)) * 1.5;
        scrollContainer.scrollLeft = scrollLeft - walk;
      }
    }, { passive: false });
    
    // Prevent clicks on links/buttons after dragging (for touch)
    scrollContainer.addEventListener('click', function(e) {
      if (hasMoved) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    }, { capture: true });
  };

  BestSellersTabs.prototype.initScrollBarDrag = function(scrollContainer, scrollBar, productsList) {
    var self = this;
    var isDragging = false;
    var startX;
    var startScrollLeft;

    scrollBar.addEventListener('mousedown', function(e) {
      isDragging = true;
      scrollBar.classList.add('is-dragging');
      startX = e.clientX;
      startScrollLeft = scrollContainer.scrollLeft;
      e.preventDefault();
    });

    document.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      e.preventDefault();
      
      var scrollWidth = productsList.scrollWidth;
      var clientWidth = scrollContainer.clientWidth;
      var maxScroll = scrollWidth - clientWidth;
      
      if (maxScroll <= 0) return;
      
      var deltaX = e.clientX - startX;
      var scrollBarWidth = scrollBar.offsetWidth;
      var progressBarWidth = scrollBar.parentElement.offsetWidth;
      var maxBarTranslate = progressBarWidth - scrollBarWidth;
      
      if (maxBarTranslate <= 0) return;
      
      var scrollRatio = maxScroll / maxBarTranslate;
      var newScrollLeft = startScrollLeft + (deltaX * scrollRatio);
      
      newScrollLeft = Math.max(0, Math.min(newScrollLeft, maxScroll));
      scrollContainer.scrollLeft = newScrollLeft;
    });

    document.addEventListener('mouseup', function() {
      if (isDragging) {
        isDragging = false;
        scrollBar.classList.remove('is-dragging');
      }
    });
  };

  BestSellersTabs.prototype.switchTab = function(index) {
    var self = this;
    
    this.tabs.forEach(function(tab, i) {
      if (i === index) {
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
      } else {
        tab.classList.remove('is-active');
        tab.setAttribute('aria-selected', 'false');
      }
    });

    this.panels.forEach(function(panel, i) {
      if (i === index) {
        panel.classList.add('is-active');
        panel.setAttribute('aria-hidden', 'false');
        
        setTimeout(function() {
          var scrollContainer = panel.querySelector('[data-scroll-container]');
          var scrollBar = panel.querySelector('[data-scroll-bar]');
          var productsList = panel.querySelector('.BestSellers__ProductsList');
          
          if (scrollContainer && scrollBar && productsList) {
            scrollContainer.scrollLeft = 0;
            self.updateScrollBar(scrollContainer, scrollBar, productsList);
          }
        }, 50);
      } else {
        panel.classList.remove('is-active');
        panel.setAttribute('aria-hidden', 'true');
      }
    });
  };

  BestSellersTabs.prototype.updateScrollBar = function(scrollContainer, scrollBar, productsList) {
    var scrollWidth = productsList.scrollWidth;
    var clientWidth = scrollContainer.clientWidth;
    var scrollLeft = scrollContainer.scrollLeft;
    
    if (scrollWidth <= clientWidth) {
      scrollBar.style.width = '100%';
      scrollBar.style.transform = 'translateX(0)';
      return;
    }
    
    var barWidth = (clientWidth / scrollWidth) * 100;
    var maxScroll = scrollWidth - clientWidth;
    var scrollPercent = scrollLeft / maxScroll;
    var maxTranslate = clientWidth - (clientWidth * barWidth / 100);
    
    scrollBar.style.width = barWidth + '%';
    scrollBar.style.transform = 'translateX(' + (scrollPercent * maxTranslate) + 'px)';
  };

  document.addEventListener('DOMContentLoaded', function() {
    var sections = document.querySelectorAll('[data-section-type="best-sellers-tabs"]');
    sections.forEach(function(section) {
      new BestSellersTabs(section);
    });
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      var section = event.target.querySelector('[data-section-type="best-sellers-tabs"]');
      if (section) {
        new BestSellersTabs(section);
      }
    });
  }
})();
